import * as React from 'react';
import rewardPlaceholder from '../../../assets/reward-placeholder.svg';
import './progress-block-tier.styles.less';

export const ProgressBlockTier: React.FC<IProps> = ({ title, imageSrc, onClick }) => (
    <div className="sitegen-friend-referral-progress-tier" onClick={onClick}>
        <img className="sitegen-friend-referral-progress-tier__img" 
            src={ imageSrc || rewardPlaceholder }
        />

        <div className="sitegen-friend-referral-progress-tier__title">
            { title }
        </div>
    </div>
);

interface IProps {
    title: React.ReactNode;
    imageSrc?: string;
    onClick: () => void;
}

export {
    IProps,
    rewardPlaceholder
};
